import { AdditionalFilterItem, AdditionalGroupResponseItem } from '@/types/service-response'
import { AdditionalFieldItem } from '@/model/additional-fields/AdditionalFieldItem'

export class AdditionalField {
  public constructor (
    readonly label: string,
    readonly type: number,
    readonly name: string,
    readonly value: string,
    readonly componentId: number,
    readonly groupId: number,
    readonly items: AdditionalFieldItem[],
    readonly project: number | null
  ) {}

  public static createFromResponse (responseData: AdditionalGroupResponseItem): Array<AdditionalField> {
    let result: Array<AdditionalField> = []
    if (responseData) {
      result = responseData.Filters.map((item: AdditionalFilterItem ) => {
        const items: AdditionalFieldItem[] = AdditionalFieldItem.createFromResponse(item, responseData.GroupID, responseData.Projekt ? responseData.Projekt : null)
        return new AdditionalField(
          item.Label,
          item.Feldtyp,
          item.Name,
          item.Value ? item.Value : '',
          item.Art,
          responseData.GroupID,
          items,
          responseData.Projekt ? responseData.Projekt : null
        )
      })
    }
    return result
  }

  public static updateValue (item: AdditionalField, value: string): AdditionalField {
    return new AdditionalField(
      item.label,
      item.type,
      item.name,
      value,
      item.componentId,
      item.groupId,
      item.items,
      item.project
    )
  }
}